var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cursor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Cursor_2",
    d: "M12.608 23.7621L7.11732 8.0662C6.83381 7.25574 7.64803 6.49353 8.44844 6.82012L23.9497 13.145C24.7739 13.4813 24.7814 14.6354 23.9616 14.9814L21.649 15.9573C19.003 17.0739 16.8477 19.0915 15.5722 21.6458L14.4574 23.8784C14.0623 24.6698 12.8999 24.5967 12.608 23.7621Z",
    fill: "#CFF85B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCursor);
export default __webpack_public_path__ + "static/media/green-cursor.ee50c369e8d685c29e04768bd9f0524a.svg";
export { ForwardRef as ReactComponent };